import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DownArrowIcon } from "../../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../../assets/appearencePage/arrow-down-dark.svg";
import { ReactComponent as TextSvgIcon } from "../../../../../assets/appearencePage/text.svg";

import { toast } from "react-hot-toast";

import { useDispatch, useSelector } from "react-redux";
import { createFontSettings } from "../../../../../redux/slices/appearance/createFontSettingsSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import AppearanceDeleteButton from "../../../../../components/common/buttons/AppearanceDeleteButton";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

const FontAcc = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const modalRef = useRef();
  const iconRef = useRef();
  const [subLoading, setSubLoading] = useState(false);
  const [fontDropDown, setFontDropDown] = useState(false);
  const [selectedFont, setSelectedFont] = useState(null);
  const colorDropDownRef = useRef();
  const colorDropDownBtnRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        fontDropDown &&
        modalRef.current &&
        !modalRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setFontDropDown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontDropDown]);
  const [color, setColor] = useState("#CAFF");
  const [fontColor, setFontColor] = useColor("#CAFF");
  useEffect(() => {
    setColorHandler(fontColor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontColor]);
  const setColorHandler = (color) => {
    setColor(color.hex);
  };

  const [openColorPicker, setOpenColorPicker] = useState(false);

  // Custom color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openColorPicker &&
        colorDropDownRef.current &&
        !colorDropDownRef.current.contains(e.target) &&
        !colorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenColorPicker(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openColorPicker]);

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const fonts = [
    { value: "arial", label: "Arial" },
    { value: "verdana", label: "Verdana" },
    { value: "helvetica", label: "Helvetica" },
    { value: "inter", label: "Inter" },
    { value: "lato", label: "Lato" },
    { value: "open_sans", label: "Open Sans" },
    { value: "montserrat", label: "Montserrat" },
    { value: "karla", label: "Karla" },
    { value: "inconsolata", label: "Inconsolata" },
  ];

  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item?.coloum_name === "fonts") {
        const value = JSON.parse(item.coloum_value);
        setSelectedFont(value?.fontType);
        setColor(value.fontColor || "#CAFF");
        setFontColor((color) => {
          return { ...color, hex: value.fontColor || "#CAFF" };
        });
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  const submitHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");
    if (selectedFont === null) {
      toast.error("Please select a font");
    } else {
      const data = {
        fontType: selectedFont,
        fontColor: color,
        linkId: linkId,
        userId: userId,
      };
      setSubLoading(true);

      await dispatch(createFontSettings(data)).then(() => {
        dispatch(gettingSettingUpdataData(user));
        dispatch(getScreenPreviewSetting(pageName));
      });

      setSubLoading(false);
    }
  };

  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const data = {
      fontType: "",
      fontColor: "#CAFF",
      linkId: linkId,
      userId: userId,
    };
    setColor("#CAFF");
    setDeleteStylePending(true);

    await dispatch(createFontSettings(data)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });

    setDeleteStylePending(false);
  };

  return (
    <div className="mt-[20px] lg:mt-[30px]">
      <div className="relative">
        <div
          ref={iconRef}
          onClick={() => setFontDropDown(!fontDropDown)}
          className="relative cursor-pointer flex items-center gap-2.5 bg-light_bg_v4 dark:bg-[#404040] text-heading_color dark:text-color_v1_dark text-small2 lg:text-small1 rounded-md w-full px-[14px] lg:px-[15px] py-[13px] lg:py-[11px] dark:border-color_v2_dark"
        >
          <div className="flex item-center justify-center">
            {darkMode ? (
              <TextSvgIcon className={`stroke-color_v1_dark`} />
            ) : (
              <TextSvgIcon className={`stroke-heading_color`} />
            )}
          </div>
          <button
            onClick={() => setFontDropDown(!fontDropDown)}
            id="fonts"
            className="w-full focus:outline-none text-start text-heading_color dark:text-color_v1_dark  text-small2 lg:text-small1 capitalize"
          >
            {selectedFont ? selectedFont?.label : translate("cms.select_font")}
          </button>
          <div
            onClick={() => setFontDropDown(!fontDropDown)}
            className="text-xl cursor-pointer"
          >
            {darkMode ? (
              <DownArrowIconDark className="h-[16px] w-[16px]" />
            ) : (
              <DownArrowIcon className="h-[16px] w-[16px]" />
            )}
          </div>
        </div>
        {fontDropDown && (
          <div
            ref={modalRef}
            className="absolute top-12 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-[130px] overflow-y-auto"
          >
            {fonts.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => {
                    setSelectedFont(item);
                    setFontDropDown(false);
                  }}
                  className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] text-small2 md:text-body_copy2 text-heading_color dark:text-color_v1_dark  cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md capitalize"
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="relative flex items-center justify-start w-full my-2.5 lg:my-5">
        <div
          ref={colorDropDownBtnRef}
          onClick={() => setOpenColorPicker(!openColorPicker)}
          style={{
            background: color,
          }}
          className="border rounded-md me-[16px] lg:me-[19px] cursor-pointer min-w-[48px] min-h-[48px] w-[48px] h-[48px] relative"
        ></div>
        {openColorPicker && (
          <div
            className="absolute top-0 lg:w-[80%] 2xl:w-[60%] w-full pb-5 "
            style={{ zIndex: "999999999" }}
          >
            <div
              ref={colorDropDownRef}
              className="border bg-white shadow-xl rounded-lg p-3"
            >
              <ColorPicker
                color={fontColor}
                onChange={setFontColor}
                hideInput={true}
                height={150}
              />
              <div className="flex flex-wrap xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                <div className="flex justify-center items-center gap-1 w-full">
                  <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                    <p>HEX</p>
                  </div>
                  <p>:</p>
                  <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                    <p>{fontColor?.hex}</p>
                  </div>
                </div>
                <div className="flex gap-1 justify-between w-full ">
                  <div className="border rounded-md px-1 py-0.5 text-small1">
                    {Math.round((fontColor?.rgb?.a / 1) * 100)}%
                  </div>
                  <button
                    className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                    onClick={() => setOpenColorPicker(false)}
                  >
                    DONE
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="w-full overflow-hidden">
          <div className="text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
            {/* Color */}
            {translate("color")}
          </div>
          <div className="text-small2_b text-heading_color dark:text-color_v1_dark ">
            <input
              value={color || "#CAFF"}
              type="text"
              className="focus:outline-none -mt-[8px] dark:bg-dark-secondary"
              onChange={(e) => {
                setFontColor((color) => {
                  return { ...color, hex: e.target.value };
                });
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex mt-[25px] cursor-pointer items-center justify-end">
        <AppearanceDeleteButton
          isLoading={deleteStylePending}
          onClickHandler={deleteHandler}
        />
        {/* <button
          onClick={() => submitHandler()}
          className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
            subLoading ? "opacity-70" : ""
          } `}
        >
          {subLoading ? (
            <svg
              aria-hidden="true"
              role="status"
              className="inline w-3 h-3 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            "SAVE"
          )}
          </button> */}
        <ExtraSmallFilledButton
          name={`${translate("biolink_title.save_cap")}`}
          buttonType={"button"}
          isLoading={subLoading}
          onClickHandler={submitHandler}
          classes={"ms-3"}
        />
      </div>
    </div>
  );
};

export default FontAcc;
